export default __webpack_public_path__ + "static/media/logo-white.41521b1f.png";